import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserService} from 'src/app/shared/service/user.service';
import {HttpClient} from '@angular/common/http';
import {DateService} from 'src/app/shared/service/date.service';
import {SubSink} from 'subsink';
import {Currency} from 'src/app/shared/models/currency.model';
import {User} from 'src/app/shared/models/user.model';
import {TransactionType, UserTransaction} from "../../../shared/models/user-transaction.model";
import {Pagination} from "../../../shared/models/pagination.model";
import {UserTransactionService} from "../../../shared/service/user-transaction.service";
import {
  ReconciliationUserTransactionComponent
} from "../user-edit/components/contradiction/reconciliation-user-transaction.component";
import {combineLatest, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {Contradiction, IContradiction} from "../../../shared/models/contradiction.model";
import {NbDialogService} from "@nebular/theme";
import {CurrencyService} from "../../../shared/service/currency.service";
import {ContradictionService} from "../../../shared/service/contradiction.service";
import Swal from "sweetalert2";
import Big, {RoundingMode} from "big.js";

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit, OnDestroy {
  @Input() userId!: number;
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
  market = 'real';
  tableLoading = false;
  pagination: Pagination<UserTransaction> = new Pagination<UserTransaction>();
  page = 1;
  limit = 15;
  first = 0;
  includedUsers: User[] = [];
  excludedUsers: User[] = [];
  type: TransactionType = TransactionType.ALL;
  contradictions: IContradiction[] = []
  contradictionLoading = false;
  currencies: Currency[] = [];
  error: any = {};


  private sub = new SubSink();
  protected readonly TransactionType = TransactionType;

  constructor(
    private userService: UserService,
    private http: HttpClient,
    private dateService: DateService,
    private userTransaction: UserTransactionService,
    private dialogService: NbDialogService,
    private currency: CurrencyService,
    private contradictionService: ContradictionService
  ) {
  }

  ngOnInit(): void {
  }

  getContradictionTable() {
    this.contradictionLoading = true
    this.sub.sink = combineLatest([this.getMarket(), this.getContradiction()]).pipe(
      map(([currency, contradiction]) => {
        currency.map((coin) => {
          if (coin.id === 'IRR') {
            coin.name = 'ریال'
          }
          if (Big(new Big(contradiction[coin.id] ?? 0).toFixed(8)).toNumber()) {
            let amount = Big(contradiction[coin.id] ?? 0).toNumber();
            if (coin.id === 'IRR') {
              amount = new Big(amount).div(10).round(Big.roundDown).toNumber()
            }
            this.contradictions.push({...coin, contradiction: amount})
          }
        })
      }),
    ).subscribe({
      next: () => {
        if (this.contradictions.length) {
          this.openContradictionModal()
        } else {
          this.Toast.fire({
            icon: 'info',
            title: 'مغایرتی یافت نشد',
            position: 'bottom-left'
          })
        }
        this.contradictionLoading = false
      },
      error: (err) => {
        console.error(err);
        this.contradictionLoading = false
        this.Toast.fire({
          icon: 'error',
          title: 'عملیات با خطا مواجه شد',
          position: 'bottom-left'
        })
      }
    })
  }

  getMarket(): Observable<Currency[]> {
    return this.currency.getCurrencies();
  }

  getContradiction(): Observable<Contradiction> {
    return this.contradictionService.getContradiction(this.userId)
  }

  openContradictionModal() {
    this.dialogService.open(ReconciliationUserTransactionComponent, {
      hasBackdrop: true, dialogClass: 'note-modal-container', context: {
        allContradiction: this.contradictions
      }
    }).onClose.subscribe(() => {
      this.contradictions = []
    })
  }

  filterTable($event: any = {}): void {
    const startDate = $event.startDate ?? this.dateService.previousWeek();
    const endDate = $event.endDate ?? this.dateService.todayStringGregorian();

    const filters: Record<string, number[] | string | string[] | number> = {
      timezoneOffset: new Date().getTimezoneOffset(),
    };

    if (!this.userId) {
      filters.startDate = startDate;
      filters.endDate = endDate;
    }

    if (this.currencies) {
      filters.currency_id = this.currencies.map((currency) => currency.id);
    }
    if (this.includedUsers.length > 0) {
      filters.user_id_included = this.includedUsers.map(user => user.id);
    }
    if (this.userId) {
      filters.user_id_included = [this.userId];

    }
    if (this.excludedUsers.length > 0) {
      filters.user_id_exluded = this.excludedUsers.map(user => user.id);
    }
    if (this.type !== TransactionType.ALL) {
      filters.type = this.type;
    }
    if (this.market !== 'all') {
      filters.market = this.market;
    }
    this.tableLoading = true;
    this.userService.getUserTransactions(filters)
      .subscribe((response) => {
        this.tableLoading = false;
        this.pagination = response;
        this.first = 0;
      });
  }

  changeRecordPerPageLimit(limit: number): void {
    this.limit = limit;
    this.first = 0
  }


  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
